export default __webpack_public_path__ + "static/media/canones.25ff4fa7.png";